export function reverseGeocode(geocoder, latLng){
    return new Promise(function(resolve, reject) {
        geocoder.geocode({'location': latLng}, function(results, status) {
            if (status === 'OK') {
                if (results[0]) {
                    resolve(results[0])
                }
            } else {
                // eslint-disable-next-line prefer-promise-reject-errors
                reject({
                    status
                })
            }
        })
    })
}

export function InitZoomControl (zoomDiv, map, google) {
    SetZoomControl(zoomDiv, map, google)

    zoomDiv.index = 1
    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomDiv)
}

function SetZoomControl (controlDiv, map, google) {
    // Creating divs & styles for custom zoom control
    controlDiv.style.padding = '5px'
    controlDiv.style.display = 'flex'
    // Set CSS for the control wrapper
    var controlWrapper = document.createElement('div')
    controlWrapper.style.backgroundColor = '#fff'
    controlWrapper.style.border = '2px solid #fff'
    controlWrapper.style.borderRadius = '3px'
    controlWrapper.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)'
    controlWrapper.style.cursor = 'pointer'
    controlWrapper.style.display = 'flex'
    controlDiv.appendChild(controlWrapper)

    // Set CSS for the zoomOut
    var zoomOutButton = document.createElement('div')
    zoomOutButton.classList.add('google-minus-btn')
    controlWrapper.appendChild(zoomOutButton)

    // Set CSS for the zoomIn
    var zoomInButton = document.createElement('div')
    zoomInButton.classList.add('google-plus-btn')
    controlWrapper.appendChild(zoomInButton)

    // Setup the click event listener - zoomIn
    google.maps.event.addDomListener(zoomInButton, 'click', function () {
      map.setZoom(map.getZoom() + 1)
    })

    // Setup the click event listener - zoomOut
    google.maps.event.addDomListener(zoomOutButton, 'click', function () {
      map.setZoom(map.getZoom() - 1)
    })
}

export function InitTypeControl (type, callback) {
    var centerControlDiv = document.createElement('div');
    centerControlDiv.classList.add("google-type-holder")
    centerControlDiv.setAttribute("id", "google-type-holder")
    centerControlDiv.style.border = "2px solid #2EA3FF"
    var mapType = type + ""

    var controlText = document.createElement('div');
    controlText.setAttribute("id", "google-type-text")
    centerControlDiv.classList.add("google-type-text")
    controlText.innerHTML = 'Select location by Zipcode';
    centerControlDiv.appendChild(controlText);

    var iconDiv = document.createElement('div')
    iconDiv.setAttribute("id", "google-type-icon")
    iconDiv.classList.add("google-type-icon")
    iconDiv.classList.add("google-zipcode-icon")
    centerControlDiv.appendChild(iconDiv);

    centerControlDiv.addEventListener('click', function () {
        if (mapType === 'geofence') {
            mapType = 'zipcode'
            controlText.innerHTML = 'Select location by Geofence'
            iconDiv.classList.remove("google-geofence-icon")
            iconDiv.classList.add("google-zipcode-icon")
            callback(mapType)
        } else {
            mapType = 'geofence'
            controlText.innerHTML = 'Select location by Zipcode'
            iconDiv.classList.remove("google-zipcode-icon")
            iconDiv.classList.add("google-geofence-icon")
            callback(mapType)
        }
    })

    return centerControlDiv
}

export function InitTrafficVolume (map, google, pos) {
    var trafficDiv = SetTrafficVolume()
    console.log("Pos is ", pos)
    trafficDiv.index = 2
    // if(pos === 'TOP_LEFT') {
    //     map.controls[google.maps.ControlPosition.TOP_LEFT].push(trafficDiv)
    // } else {
    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(trafficDiv)
    // }
}

function SetTrafficVolume () {
    // The whole blue container
    let trafficContainer = document.createElement('div')
    trafficContainer.classList.add("google-traffic-container")
    trafficContainer.setAttribute("id", "google-traffic-container")

    let loadingDiv = document.createElement('div')
    loadingDiv.setAttribute("id", "google-type-loading-container")
    let loadingAnimation = document.createElement('div')
    loadingAnimation.setAttribute("id", "google-type-loading-animation")
    loadingDiv.appendChild(loadingAnimation)
    trafficContainer.appendChild(loadingDiv)

    // The yellow header
    const trafficHeader = document.createElement('p')
    trafficHeader.innerHTML = 'TRAFFIC VOLUME'
    trafficHeader.classList.add('traffic-header')
    trafficContainer.appendChild(trafficHeader)

    // The container for the values
    const trafficRow = document.createElement('div')
    trafficRow.style.display = 'flex'
    trafficContainer.appendChild(trafficRow)

    // Container for the people label and value
    const trafficPeopleContainer = document.createElement('div')
    trafficPeopleContainer.classList.add('people-container')
    trafficRow.appendChild(trafficPeopleContainer)

    // People label
    const trafficPeopleHeader = document.createElement('p')
    trafficPeopleHeader.innerHTML = 'PEOPLE (per hour)'
    trafficPeopleHeader.classList.add('people-header')
    trafficPeopleContainer.appendChild(trafficPeopleHeader)

    // People value
    let trafficPeopleValue = document.createElement('div')
    let trafficPeopleMin = document.createElement('p')
    trafficPeopleMin.setAttribute("id", "traffic-people-min")
    let trafficPeopleTo = document.createElement('p')
    trafficPeopleTo.setAttribute("id", "traffic-people-to")
    let trafficPeopleMax = document.createElement('p')
    trafficPeopleMax.setAttribute("id", "traffic-people-max")
    trafficPeopleValue.appendChild(trafficPeopleMin)
    trafficPeopleValue.appendChild(trafficPeopleTo)
    trafficPeopleValue.appendChild(trafficPeopleMax)

    trafficPeopleValue.classList.add("people-value")
    trafficPeopleValue.setAttribute('id', 'traffic-people-value')
    trafficPeopleContainer.appendChild(trafficPeopleValue)

    // Container for average label and value
    const trafficAverageContainer = document.createElement('div')
    trafficAverageContainer.classList.add('average-container')
    trafficRow.appendChild(trafficAverageContainer)

    // Average label
    const trafficAverageHeader = document.createElement('p')
    trafficAverageHeader.innerHTML = 'AVERAGE'
    trafficAverageHeader.classList.add('average-header')
    trafficAverageContainer.appendChild(trafficAverageHeader)

    // Average value
    let trafficAverageValue = document.createElement('p')
    trafficAverageValue.innerHTML = ""
    trafficAverageValue.classList.add("average-value")
    trafficAverageValue.setAttribute('id', 'traffic-average-value')
    trafficAverageContainer.appendChild(trafficAverageValue)

    return trafficContainer
}


// export function InitResizeIcons () {
//     var interval = setInterval(() => {
//         var mainHolder = document.querySelectorAll('*[style="position: absolute; left: 0px; top: 0px; z-index: 106; width: 100%;"]')
//         if(mainHolder.length > 0){
//             var circleDivs = mainHolder[0].children[0].children[0]//.children[0]
//             console.log("Circle divs are ", circleDivs)
//             // circleDivs.classList.add('center__icon')
//             circleDivs.addEventListener('click', function() {
//                 console.log("Mouse up from it ")
//             })
//             clearInterval(interval)
//         }
//     })
// }